import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { ArrowLeft } from "react-feather";

export default function Header(props) {
  return (
    <header className="mt-6 mb-5">
      {props.breadcrumbText && props.breadcrumbUrl && (
        <Row className="pb-5 ">
          <Col lg={{ span: 10, offset: 1 }}>
            <ArrowLeft
              className="mr-1"
              size="20"
              strokeWidth="3"
              stroke="#4C76BA"
              aria-label="pil venstre/tilbake"
            />
            <a
              href={props.breadcrumbUrl}
              className="link-icon-group font-weight-bold"
            >
              <span className="link link-bold">{props.breadcrumbText} </span>{" "}
            </a>
          </Col>
        </Row>
      )}
      {props.title && (
        <Row>
          <Col lg={{ span: 10, offset: 1 }}>
            <h1 className="text-center mb-4">{props.title}</h1>
          </Col>
        </Row>
      )}
      {props.lead && (
        <Row>
          <Col lg={{ span: 8, offset: 2 }}>
            <p className="lead text-center">{props.lead}</p>
          </Col>
        </Row>
      )}
    </header>
  );
}

Header.propTypes = {
  title: PropTypes.string,
  lead: PropTypes.string,
  breadcrumbText: PropTypes.string,
  breadcrumbUrl: PropTypes.string,
};
